
import React from 'react';

const ProcessStepsSection = () => {
  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container px-4 sm:px-6 md:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-center mb-8 text-joerg-800">So läuft's ab</h2>
          
          <div className="space-y-6 md:space-y-8">
            <div className="flex gap-4 items-start bg-white p-5 rounded-lg border border-joerg-100 shadow-sm transition-all duration-300 hover:shadow-md">
              <div className="flex items-center justify-center">
                <div className="bg-[#2F855A] text-white rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0">1</div>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-medium text-joerg-800">Du vereinbarst ein kostenfreies Erstgespräch.</h3>
                <p className="mt-2 text-joerg-600">Ein unkomplizierter 30-minütiger Termin, bei dem wir uns kennenlernen.</p>
              </div>
            </div>
            
            <div className="flex gap-4 items-start bg-white p-5 rounded-lg border border-joerg-100 shadow-sm transition-all duration-300 hover:shadow-md">
              <div className="flex items-center justify-center">
                <div className="bg-[#2F855A] text-white rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0">2</div>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-medium text-joerg-800">Wir besprechen dein Anliegen und deine Ziele.</h3>
                <p className="mt-2 text-joerg-600">Du teilst, was dich bewegt und wohin du möchtest – ich höre aufmerksam zu.</p>
              </div>
            </div>
            
            <div className="flex gap-4 items-start bg-white p-5 rounded-lg border border-joerg-100 shadow-sm transition-all duration-300 hover:shadow-md">
              <div className="flex items-center justify-center">
                <div className="bg-[#2F855A] text-white rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0">3</div>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-medium text-joerg-800">Du bekommst eine transparente Empfehlung.</h3>
                <p className="mt-2 text-joerg-600">Gemeinsam erarbeiten wir einen Weg, der perfekt zu deinen Bedürfnissen passt.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessStepsSection;
